import { useEffect, useRef, useState } from 'react'
import { Box, InputLabel, TextareaAutosize } from '@mui/material'
import { isNotEmpty } from '../../utils/helpers'
import formMaxCharacters from '../../utils/formMaxCharacters'
import UseTranslation from '../../hooks/UseTranslation'
import { ReactComponent as TeamSnap } from '../../images/TeamSnap.svg'

const OfoqTextArea = ({
  name, defaultValue, refState, required, customPlaceHolder, customStyle,
  error,
  helperText,
  ...props
}) => {
  const placeHolder = name?.split('_').join(' ')
  const textFieldRef = useRef()
  const [notValidField, setNotValidField] = useState(false)
  const { t } = UseTranslation()

  const updateRefState = () => {
    if (required) {
      if (isNotEmpty(textFieldRef.current.value)) {
        refState(textFieldRef.current.value)
        setNotValidField(false)
      } else {
        refState(null)
        setNotValidField(true)
      }
    } else {
      refState(textFieldRef.current.value)
    }
  }

  useEffect(() => {
    if (defaultValue) {
      textFieldRef.current.value = defaultValue
    }
  }, [defaultValue])

  return (
    <Box sx={[styles.root(error), customStyle]}>
      <InputLabel
        htmlFor={name}
        variant="heading6"
        sx={styles.formInputLabel}
      >
        {placeHolder}
        {required && <TeamSnap style={styles.snapIcon} data-testid="teamsnap-icon" />}

      </InputLabel>

      <TextareaAutosize
        onChange={updateRefState}
        defaultValue={defaultValue}
        required={!!required}
        type="text"
        placeholder={customPlaceHolder || `${t?.['type the']} ${placeHolder}`}
        ref={textFieldRef}
        maxLength={formMaxCharacters.textArea}
        style={customStyle}
        {...props}
      />
 {defaultValue?.length >= formMaxCharacters.textArea && (
        <Box sx={styles.overCountStyle}>
          {t?.['You have reached the maximum characters']}
        </Box>
 )}
      {(notValidField || error) && (
        <Box sx={styles.errorMSG}>
          {helperText || `${t?.['please enter']}
          ${placeHolder}`}
        </Box>
      )}
    </Box>
  )
}

const styles = {
  root: (error) => ({
    width: '100%',
    margin: '20px 0',
    '& textarea': {
      width: '100%',
      minHeight: '70px',
      padding: '16px',
      borderRadius: '12px',
      border: 'solid 1px',
      borderColor: error ? 'error.main' : 'grey.200',
      borderWidth: '2px',
      borderStyle: 'solid',
      backgroundColor: 'background.default',
      boxSizing: 'border-box',
      outline: 'none !important',
      fontFamily: 'Avenir',
      fontSize: '14px',
    },
    '& textarea::placeholder': {
      fontSize: '14px',
      textTransform: 'capitalize',
      color: 'grey.100',
    },
  }),
  formInputLabel: {
    display: 'flex',
    alignItems: 'center',
    transform: 'translate(0,0) scale(1)',
    textTransform: 'capitalize',
    color: 'text.primary',
    width: 'max-content',
    paddingRight: '18px',
    marginBottom: '15px',
    fontSize: '14px',
  },

  snapIcon: {
    marginInlineStart: '8px',
  },
  errorMSG: {
    color: 'error.main',
    margin: '0',
    marginTop: '5px',
    fontSize: '0.75rem',
  },
  overCountStyle: {
    marginTop: '5px',
    padding: '4px',
    fontSize: { xs: '13px', sm: '14px' },
    borderRadius: '7px',
    color: 'text.disabled',
  },
}

export default OfoqTextArea
